import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export async function downloadFile(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const dispo = res.headers["content-disposition"] || "";
  const m = dispo.match(/filename=([^;]+)/);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = m ? m[1].replace(/"/g, "").trim() : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

const FIELD_LABELS = {
  nome: "Nome",
  cognome: "Cognome",
  codice_fiscale: "Codice Fiscale",
  email: "Email",
  password: "Password",
  conferma_password: "Conferma password",
  privacy: "Privacy",
  nome_cognome: "Nome e Cognome",
  nome_locale: "Nome del locale",
  indirizzo_locale: "Indirizzo del locale",
  citta: "Città",
  provincia: "Provincia",
  cap: "C.A.P.",
  attivita: "Attività",
  data_esibizione: "Data dell'esibizione",
  importo: "Importo",
  importo_servizio: "Importo del servizio",
  email_certificato: "Email per il certificato",
  messaggio: "Messaggio",
  stato: "Stato",
  token: "Token",
  password_corrente: "Password attuale",
  password_attuale: "Password attuale",
  nuova_password: "Nuova password",
};

const MSG_RULES = [
  [/field required/i, "campo obbligatorio mancante"],
  [/at least 8 characters/i, "deve contenere almeno 8 caratteri"],
  [/valid email/i, "indirizzo email non valido"],
  [/valid date/i, "data non valida"],
  [/greater than 0/i, "deve essere maggiore di zero"],
];

function fieldLabel(loc) {
  if (!Array.isArray(loc)) return null;
  const key = loc[loc.length - 1];
  return FIELD_LABELS[key] || (typeof key === "string" ? key : null);
}

function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

function translateValidationItem(item) {
  if (!item || typeof item !== "object") return String(item);
  const raw = typeof item.msg === "string" ? item.msg : "";
  const cleaned = raw.replace(/^Value error,\s*/i, "");
  const rule = MSG_RULES.find(([pattern]) => pattern.test(cleaned));
  const text = rule ? rule[1] : cleaned;
  const field = fieldLabel(item.loc);
  return field ? `${field}: ${capitalize(text)}` : capitalize(text);
}

export function formatApiError(error, fallback = "Si è verificato un errore. Riprova.") {
  const detail = error?.response?.data?.detail;
  if (detail == null) {
    if (error?.code === "ERR_NETWORK") return "Impossibile contattare il server. Controlla la connessione e riprova.";
    return fallback;
  }
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map(translateValidationItem).filter(Boolean);
    return msgs.length ? msgs.join(" — ") : fallback;
  }
  if (detail && typeof detail.msg === "string") return translateValidationItem(detail);
  return fallback;
}

export default api;
